import * as React from 'react'
import { memo } from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="currentColor" {...props}>
    <path
      fill="currentColor"
      d="M5.333 36c-.472 0-.867-.16-1.186-.48a1.62 1.62 0 0 1-.48-1.187 1.604 1.604 0 0 1 .48-1.186c.32-.32.716-.48 1.186-.48h33.334c.472 0 .868.16 1.188.48.32.32.48.715.478 1.186a1.626 1.626 0 0 1-.48 1.189c-.319.32-.714.48-1.186.478H5.333Zm3.334-5a3.208 3.208 0 0 1-2.354-.978 3.216 3.216 0 0 1-.98-2.355V9.333c0-.916.327-1.7.98-2.353A3.218 3.218 0 0 1 8.667 6h26.666c.917 0 1.702.327 2.355.98.654.653.98 1.438.979 2.353v18.334c0 .916-.326 1.701-.979 2.355a3.202 3.202 0 0 1-2.355.978H8.667Zm0-3.333h26.666V9.333H8.667v18.334Z"
    />
  </svg>
)
const Memo = memo(SvgComponent)
export default Memo
